import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC001_Request,
  IAPI_ACC001_Response,
  IAPI_ACC011_Request,
  IAPI_ACC011_Response,
} from "../../../type/apiType";

// 機構ユーザ一覧参照
const httpAPI_ACC011 = async (
  param: IAPI_ACC011_Request
): Promise<IAPI_ACC011_Response> => {
  let res = await http.post(ApiUrl.API_ACC011, {
    ...param,
  });

  return res.data;
};

// ユーザアカウント失効化
const httpAPI_ACC001 = async (
  param: IAPI_ACC001_Request
): Promise<IAPI_ACC001_Response> => {
  let res = await http.post(ApiUrl.API_ACC001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC011, httpAPI_ACC001 };
